import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = { style: {"list-style":"none","padding":"0","margin":"0"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { ref } from 'vue';
import Chip from 'primevue/chip';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';
import BuildingsListActions from './BuildingsListActions.vue';
import AdminManageBuildingModal from './AdminManageBuildingModal.vue';
import ClinicianCreateBuildingModal from './ClinicianCreateBuildingModal.vue';
import { usePeopleTypesStore } from '@/store';

type CreateBuildingData = {
  name: string;
  attachClinicians?: number[];
};

type PeopleFilterInterface = {
  id: number;
  display_name: string;
  person_type_id: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BuildingsList',
  props: {
    organizationId: {},
    isAdminUser: { type: Boolean },
    totalRecords: {},
    loading: { type: Boolean },
    buildings: {},
    buildingsOrganization: {}
  },
  emits: [EMIT.REMOVE, EMIT.SAVE, EMIT.EDIT, EMIT.SYNC],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const showAddBuilding = ref(false);
const showEditBuilding = ref(false);
const building_id = ref(0);
const initialName = ref();
const initialSelectedClinicians = ref<PeopleFilterInterface[]>([]);
const showClinicianModal = ref(false);
const peopleTypesStore = usePeopleTypesStore();

const deleteBuilding = async (building) => {
  emit(EMIT.REMOVE, building);
};

const openAddBuildingModal = () => {
  showAddBuilding.value = true;
};

const closeAddBuilding = () => {
  showAddBuilding.value = false;
  showEditBuilding.value = false;
};

const createBuilding = (data: CreateBuildingData) => {
  emit(EMIT.SAVE, data);
  showAddBuilding.value = false;
  showClinicianModal.value = false;
};

const openClinicianModal = () => {
  showClinicianModal.value = true;
};

const closeClinicianModal = () => {
  showClinicianModal.value = false;
};

const openModal = () => {
  if (props.isAdminUser) {
    openAddBuildingModal();
  } else {
    emit(EMIT.SYNC);
    openClinicianModal();
  }
};

const onEditBuilding = (building: { id: number; name: string; people?: [] }) => {
  building_id.value = building.id;
  initialName.value = building.name;
  initialSelectedClinicians.value = filteredPeople(building.people) || [];
  showEditBuilding.value = true;
};

const editBuilding = async (data) => {
  data.building_id = building_id.value;
  emit(EMIT.EDIT, data);
  showAddBuilding.value = false;
  showEditBuilding.value = false;
};

const filteredPeople = (people: PeopleFilterInterface[]) => {
  return people.filter((person) => person.people_type.acronym == peopleTypesStore.PEOPLE_TYPES.CLINICIAN);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Buildings", -1)),
        _createVNode(_unref(Chip), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.totalRecords), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          (_unref(can)([_unref(PERMISSIONS).BUILDING_ASSIGN]))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                type: "text",
                size: "small",
                text: "Add Building",
                "icon-left": "add",
                onClick: openModal
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: props.buildings,
          loading: props.loading,
          "data-Key": "organization_id",
          "responsive-layout": "scroll",
          "sort-field": 'name',
          "sort-order": 1
        }, {
          empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Buildings not assigned.", -1)
          ]))]),
          default: _withCtx(() => [
            (props.totalRecords > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.isAdminUser)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_Column, {
                          field: "name",
                          header: "Buildings",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "service_providers",
                          header: "Service Providers"
                        }, {
                          body: _withCtx(({ data }) => [
                            _createElementVNode("ul", _hoisted_2, [
                              (!data.people || filteredPeople(data.people).length === 0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_3, " Service Providers not assigned "))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPeople(data.people), (person) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: person.id
                                }, _toDisplayString(person.display_name), 1))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createBlock(_component_Column, {
                        key: 1,
                        field: "building_name",
                        header: "Buildings",
                        sortable: ""
                      })),
                  (_unref(can)([_unref(PERMISSIONS).BUILDING_ASSIGN]))
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 2,
                        field: "actions",
                        header: "Actions"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createVNode(BuildingsListActions, {
                            onSave: () => deleteBuilding(data),
                            onEdit: () => onEditBuilding(data)
                          }, null, 8, ["onSave", "onEdit"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      _: 1
    }),
    (props.isAdminUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (showAddBuilding.value)
            ? (_openBlock(), _createBlock(AdminManageBuildingModal, {
                key: 0,
                "organization-id": __props.organizationId,
                mode: "add",
                onCancel: closeAddBuilding,
                onSave: createBuilding
              }, null, 8, ["organization-id"]))
            : _createCommentVNode("", true),
          (showEditBuilding.value)
            ? (_openBlock(), _createBlock(AdminManageBuildingModal, {
                key: 1,
                "organization-id": __props.organizationId,
                mode: "edit",
                "initial-name": initialName.value,
                "initial-selected-clinicians": initialSelectedClinicians.value,
                onCancel: closeAddBuilding,
                onEdit: editBuilding
              }, null, 8, ["organization-id", "initial-name", "initial-selected-clinicians"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (showClinicianModal.value)
            ? (_openBlock(), _createBlock(ClinicianCreateBuildingModal, {
                key: 0,
                buildings: props.buildings,
                "buildings-organization": props.buildingsOrganization,
                onCancel: closeClinicianModal,
                onSave: createBuilding
              }, null, 8, ["buildings", "buildings-organization"]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})